// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"Footer_styles_footerWrapper__Lsvha","footerDesc":"Footer_styles_footerDesc__2Ff24","footerAuthor":"Footer_styles_footerAuthor__1QIPn"};